module.exports = __webpack_public_path__ + "img/logo-dark.2ac99f4a.png";